import React from 'react';
import { RouteObject } from 'react-router-dom';
import ReviewWrapper from '../components/organisms/ReviewWrapper';

/**
 * Review workflow routes with ultra-simplified URL structure
 * Now uses only /:code - all steps are managed via browser history state
 * 
 * Route:
 * - /:code - Handles all review workflow steps internally
 *   Steps are tracked in history.state: 'add', 'negative', 'tip', 'payment', 'thank-you', 'done', 'tip-tech'
 */
export const reviewRoutes: RouteObject[] = [
  {
    path: '/:code',
    element: <ReviewWrapper />,
    id: 'review-main'
  }
];

/**
 * Legacy routes removed - no longer supporting old URL formats
 * The ReviewWrapper will handle all review workflow logic internally
 */
export const legacyRoutes: RouteObject[] = [];
